import {createUseStyles} from 'react-jss';
import Spacing from '../../../style-helper/Spacing';

export default createUseStyles(
  {
    basketItemImage: props => (!props.mergedGroupsEnabled ? ({
      position: 'relative',
      margin: [0, 8],
  
      '&:first-child': {
        marginLeft: Spacing.double,
        marginRight: Spacing.single,
      },
  
      '&:last-child': {
        marginLeft: Spacing.single,
        marginRight: Spacing.double,
      },
    }) : ({
      margin: [0, 8],
      position: 'relative',
    })),
    imageContainer: {
      position: 'relative',
      height: '100%',
      display: 'inline-block',
    },
    quantity: {
      color: '#fff',
      background: '#333',
      textAlign: 'center',
      zIndex: 1,
      position: 'absolute',
      width: 24,
      height: 24,
      borderRadius: '100%',
      lineHeight: '24px',
      bottom: '-5px',
      right: '-5px',
    },
    additionalItems: {
      color: '#fff',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      fontSize: 14,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
    },
    moreItemsText: {
      textAlign: 'center',
      margin: 'auto',
    },
    image: {
      maxWidth: 80,
      height: 'auto',
    },
  },
);
